import DefaultLayout from "@/layouts/DefaultLayout";
import KDeliveryNoteForm from "kinnect-front/KYard/Trips/KDeliveryNoteForm";
import {
	Broadcastable,
	FetchesData,
	Pageable
} from "kinnect-mixins";
import {
	YardTrip,
	YardTripDeliveryNote
} from "kinnect-models";

export default {
	name: "YardTripDeliveryNotePage",

	metaInfo: { title: "Yard - Trips - Edit Delivery Note" },

	props: { idTrip: Number },

	mixins: [
		Broadcastable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		deliveryNote: null,
		toolbarActions: {
			icon: "print",
			onClick: () => window.print(),
			text: "Print",
			tooltip: "Print delivery note"
		}
	} ),

	computed: {
		broadcasts() {
			if ( !this.deliveryNote || !this.deliveryNote.id ) {
				return;
			}

			return {
				Model: YardTripDeliveryNote,
				channel: `trip-delivery-note-${this.deliveryNote.id}`,
				propKey: "deliveryNote",
				eventNames: {
					u: "trip-delivery-note.updated"
				}
			};
		}
	},

	methods: {
		async fetchDeliveryNote() {
			this.deliveryNote = await new YardTripDeliveryNote()
			.for( new YardTrip( { id: this.idTrip } ) )
			.first();
		},

		async fetch() {
			await this.fetchDeliveryNote();
		}
	},

	render() {
		if ( !this.fetched ) {
			return;
		}

		return <DefaultLayout maxWidth="900px">
			<KDeliveryNoteForm deliveryNote={this.deliveryNote}></KDeliveryNoteForm>
		</DefaultLayout>;
	}
};
